module.exports = __webpack_public_path__ + "assets/search.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/search.svg
 ** module id = 146
 ** module chunks = 1
 **/